
import {Elements, CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import axios from 'axios'
import {Row, Input, Label, Button, FormGroup } from "reactstrap";

import { BASE_URL } from '../../../constants/defaultValues';
import { apiCall } from '../../../functions/utils';
const CheckoutForm = ({changeLoadingStatus}) => {
    const stripe = useStripe();
    const elements = useElements();
  
     const updateUserStorage = async() => {
      const token = localStorage.getItem('user_id');
      await axios.get(BASE_URL + '/api/auth/me', {
        headers: {
            Authorization: 'bearer ' + token
        },
    }).then(function (response) {
        let data = JSON.stringify(response.data); 
        localStorage.setItem("user",data);
        window.location.reload();
    }).catch(err => {
        console.log("User Information Error",err)
    })
      
      
    }
  
    const handleSubmit = async (event) => {
      // Block native form submission.
      event.preventDefault();
  
      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }
      // Get a reference to a mounted CardElement. Elements knows how
      // to find your CardElement because there can only ever be one of
      // each type of element.
      const cardElement = elements.getElement(CardElement);
  
      // Use your card Element with other Stripe.js APIs
      const {error, paymentMethod} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });
  
      if (error) {
        // changeLoadingStatus()
        console.log('[error]', error);
        alert("Error Catching your payment method")
      } else {
        changeLoadingStatus()
        
        console.log('[PaymentMethod]', paymentMethod);
        let form ={};
        form.stripe = paymentMethod.id
        const token = localStorage.getItem('user_id');
  
        const response = await apiCall(true, "POST", `/api/stripe/submit`, form)
        updateUserStorage()
      }
    };
  
    return (
      <form style={{width:"100%"}} onSubmit={handleSubmit}>
  
        
        <CardElement />
  
        <Button style={{marginTop:15, float:"right"}} color="secondary" type="submit" disabled={!stripe}>Add</Button>
  
  
      </form>
    );
  
  }

  export default CheckoutForm